import Card from './Card'
import SectionHeading from '../../../components/SectionHeading'
import {Explore2Icon2} from '../../../utils/allImgs'

/**
 * CardNewListed component.
 *
 * Displays a list of newly listed NFT items in a card format.
 * Shows for each item:
 * - Item image
 * - Title and description
 * - Price in SGB
 * - Buy Now button
 * - Owner avatar and link
 *
 * Uses Card component for each item. Part of Explore2 page layout.
 *
 * @param {Object} props - Component props
 * @param {Array} props.data - Array of item objects with img1, img2, text1-3, path1-3, price
 * @returns {React.ReactElement} List of new item cards
 */
const CardNewListed = ({data}) => {

  return (
    <div className="col-lg-8">
      <SectionHeading
                      img={Explore2Icon2}
                      text='Latest Items For Sale or Auction'
                      title='Newly Listed Items'
      />

      {data && data.map((item , i) => (
        <Card
          path1={item.path1}
          path2={item.path2}
          path3={item.path3}
          img1={item.img1}
          img2={item.img2}
          text1={item.text1}
          text2={item.text2}
          text3={item.text3}
          price={item.price}
        />
      ))}

    </div>
  );
}

export default CardNewListed;
